module.exports = " <div class=wxdc-setting> <x-header title=设置 :left-options=\"{showBack:true,backText:'返回'}\"></x-header> <group> <switch title=是否接收微信推送></switch> <switch title=是否接收最新活动推送 :value=true></switch> </group> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.1.6.1@eslint-loader!./src/views/Setting.vue
// module id = 277
// module chunks = 2